import type { User_IUser } from '../User/User.IUser'
import { IDB_deviceRecentUsers } from '../IDB/IDB.deviceDB'

const RECENT_DAYS = 14

export type User_LoginUser = Pick<User_IUser, 'id' | 'email' | 'name' | 'profileCircleColor'> & {
    lastActive: Date
    /** the user's profile image, cached as a Blob */
    profileImageBlob: Blob
}

function safeFetchImageBlob(url: string): Promise<Blob> {
    return fetch(url)
        .then((response) => response.blob())
        .catch(() => null)
}

let lastSuccessfullyFetchedBlob: { url: string; blob: Blob } = null
async function memoizedFetchImageBlob(url: string) {
    if (lastSuccessfullyFetchedBlob?.url === url) {
        return Promise.resolve(lastSuccessfullyFetchedBlob.blob)
    }
    const blob = await safeFetchImageBlob(url)
    if (blob) {
        lastSuccessfullyFetchedBlob = { url, blob }
    }
    return blob
}

export async function updateLastActiveTime(user: User_IUser) {
    const profileImage = user.profileImageUrl ? await memoizedFetchImageBlob(user.profileImageUrl) : null

    const loginUser: User_LoginUser = {
        id: user.id,
        email: user.email,
        name: user.name,
        profileCircleColor: user.profileCircleColor,
        lastActive: new Date(),
        profileImageBlob: profileImage,
    }

    return IDB_deviceRecentUsers().put(loginUser)
}

export function getRecentUsers() {
    const dateLimit = new Date()
    dateLimit.setDate(dateLimit.getDate() - RECENT_DAYS)

    return IDB_deviceRecentUsers().filter((user) => new Date(user.lastActive) > dateLimit)
}
